import React from 'react';
import { Operation } from '../../Transactions.types';
import * as S from './OperationRow.styles';
import { SmallChevronIcon } from '@/components/UI/Icons/Icons';

interface OperationRowProps {
  operation: Operation;
  onShowDetails: (operation: Operation) => void;
}

export function OperationRow({ operation, onShowDetails }: OperationRowProps) {
  return (
    <S.Row onClick={() => onShowDetails(operation)}>
      <S.Cell>
        {operation.ad ? (
          <S.AdLink
            href={operation.ad.path}
            onClick={event => event.stopPropagation()}
            title={operation.ad.title}
          >
            {operation.ad.title}
          </S.AdLink>
        ) : null}
      </S.Cell>

      <S.ServiceCell
        $isRefund={operation.isRefund}
        title={operation.serviceName}
      >
        {operation.serviceName}
      </S.ServiceCell>

      <S.Cell>
        <S.Amount $isIncome={operation.isIncome}>
          {operation.formattedAmount}
        </S.Amount>
      </S.Cell>

      <S.Cell title={operation.paymentMethodLabel}>
        {operation.paymentMethodLabel}
      </S.Cell>

      <S.DateCell title={operation.date}>{operation.date}</S.DateCell>

      <S.ChevronCell>
        <SmallChevronIcon width={6} height={12} />
      </S.ChevronCell>
    </S.Row>
  );
}
